import { Grid, Typography, TextField, Autocomplete } from "@mui/material";
import { BuildingRegulationsFilter } from "@shared/publicportal/contracts/BuildingRegulationsFilter";
import React from "react";
import BuildingRegulationsSearchState from "./BuildingRegulationsSearchState";
import { SearchHelper } from "../SearchHelper";

interface BuildingRegulationsSimpleSearchProps {
    state: BuildingRegulationsSearchState;
    setter: (modifier: Partial<BuildingRegulationsFilter>) => void;
}

const BuildingRegulationsSimpleSearch: React.FC<BuildingRegulationsSimpleSearchProps> = ({ state, setter }) => {
    const containerSx = state.searchType === "Advanced" ? { width: { sm: "100%", md: "80%", lg: "60%", xl: "50%" } } : undefined;
    return (
        <Grid container className="search-container search-container-simple" sx={containerSx}>
            <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                <Typography variant="h5">Reference</Typography>
            </Grid>
            <Grid size={{ xs: 12, md: state.searchType === "Advanced" ? 6 : 12, xl: state.searchType === "Advanced" ? 6 : 12 }}>
                <TextField
                    name="appRef"
                    value={state.filter.appRef || ""}
                    onChange={(event) => setter({ appRef: event.target.value })}
                    key="appRef-ref-key"
                    size="small"
                    id="appRef-ref"
                    label="Application Reference"
                    variant="outlined"
                    className="min-width-18rem"
                />
            </Grid>
            <Grid size={{ xs: 12, md: state.searchType === "Advanced" ? 6 : 12, xl: state.searchType === "Advanced" ? 6 : 12 }}>
                <Autocomplete
                    options={state.statusTypes || []}
                    id="bcApp-statusTypes"
                    className="search-form-autocomplete-field autocomplete-width-18rem"
                    key="bcApp-statusTypes-key"
                    size="small"
                    value={state.filter.status?.length ? state.filter.status : null}
                    inputValue={state.filter.status}
                    onInputChange={(event, value) => event && setter({ status: value })}
                    renderInput={(params) => SearchHelper.renderAutocompleteInput(params, "Status")}
                />
            </Grid>
        </Grid>
    );
};

export default BuildingRegulationsSimpleSearch;
